<loading *ngIf="saving" content="Saving..."></loading>
<chart [dataSet]="todayData" (onClick)="bubbleClick($event)" chartType="horizontalBar" [plugins]="todayPlugins" width="90%" [chartLabels]="todayLabels" [options]="todayOptions"></chart>
